import React from 'react';

export interface FilterCollapsibleSectionProps {
  title: string;
  open: boolean;
  onToggle: () => void;
  children: React.ReactNode;
  sectionId: string;
}

export default function FilterCollapsibleSection({
  title,
  open,
  onToggle,
  children,
  sectionId,
}: FilterCollapsibleSectionProps) {
  const panelId = `${sectionId}-panel`;

  return (
    <section className="sb-filter-section">
      <button
        type="button"
        className="sb-filter-section__toggle"
        onClick={onToggle}
        aria-expanded={open}
        aria-controls={panelId}
      >
        <span className="sb-filter-section__title">{title}</span>
        <i
          className={`fas fa-chevron-down sb-filter-section__chevron${open ? ' sb-filter-section__chevron--open' : ''}`}
          aria-hidden
        />
      </button>
      {open && (
        <div id={panelId} className="sb-filter-section__panel">
          {children}
        </div>
      )}
    </section>
  );
}
